export default __webpack_public_path__ + "static/media/PPI-pools-005.5227ad6c.jpg";